import { extend } from '../../util/jquery.js';

export default class TimeSales {
    constructor(option) {
        this.apiManager = option.apiManager;
        this.securityManager = option.securityManager;
    }
    async getTimeSales(params) {
        const securities = await this.securityManager.create(params.security);
        if (securities[0].isValid()) {
            const regex = /(\d{4})(\d{2})(\d{2})/;
            const extendParams = Object.assign({}, params, {
                tickers: securities[0].quoteInstrument
            });
            if (extendParams.sd && regex.test(extendParams.sd)) {
                extendParams.sd = extendParams.sd.replace(regex, '$3-$2-$1');
            }
            delete extendParams.security;
            const data = await this.apiManager.timeSales(extendParams);

            const resData = {};
            resData.results = data.data.map(d => {
                return extend(
                    d,
                    this.securityManager.getExtraExchangeInfo(d.exchange)
                );
            });
            resData.security = securities[0].queryKey;
            return resData;
        } else {
            throw this.securityManager.getInvalidSecuritiesError(
                params.security
            );
        }
    }
}
